import axios from 'axios'
import { navigate } from 'gatsby'

const ProductDetailApi = (getProductPayload, setPlan, toTitleCase, productDetailError) => {
  axios({
    url: `${process.env.GATSBY_API_ENDPOINT}/signup/GetProductDetail`,
    method: "POST",
    contentType: "application/json",
    data: getProductPayload(),
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then(response => {
      if (response.data !== null && response.data.Result !== null) {
        if (response.data.Result.IsPromoCodeExpired) {
          navigate("/promo-expired")
          return
        } else {
          const productArray = response.data.Result.ProductName.split(" - ")
  
          setPlan({
            product: toTitleCase(productArray[0]),
            maxCallers: `Includes ${productArray[
              productArray.length - 1
            ].trim()}`,
            total: response.data.Result.PriceText,
            billingCycle: response.data.Result.BillingCycleText.trim(),
            ratesFrom: response.data.Result.RatesFromText,
          })
        }
      } else {
        productDetailError(response.data)
      }
    })
    .catch(error => console.error(error))
}

export default ProductDetailApi